<template>
  <div
    class="price-with-btn"
    :class="{
      'is-modal': isModal,
      'is-product-tabs': productTabs,
      'is-product-page': productPage,
      'is-with-scrolling-card': withScrollingCard
    }"
  >
    <div class="price-with-btn__wrap">
      <product-price
        :old-price="oldPrice"
        :price="price"
        :vertical="true"
        :size="productPage ? 'medium' : isModal ? 'large' : ''"
        class="price-with-btn__price"
      ></product-price>
      <div class="price-with-btn__btn-wrap">
        <buy-btn
          v-if="inStock || availableInStore"
          :size="(productPage || isModal) ? 'medium' : 'small'"
          :price="price"
          :code="code"
          :title-analytics="titleAnalytics"
          :product-id="productId"
          :productPage="productPage"
          :available-in-store="availableInStore"
          :stores-data="storesData"
          :store-id="availableInStore ? availableStoreId : ''"
          class="price-with-btn__btn-buy"
        ></buy-btn>
        <!--        <buy-btn-->
        <!--          v-else-if="isNovelty"-->
        <!--          pre-order-btn-->
        <!--          :size="(productPage || isModal) ? 'medium' : 'small'"-->
        <!--          :title-ru="titleRu"-->
        <!--          :product-id="productId"-->
        <!--          :code="code"-->
        <!--          :price="price"-->
        <!--          :productPage="productPage"-->
        <!--          :class="{ 'price-with-btn__btn-buy': inStock }"-->
        <!--        ></buy-btn>-->
        <buy-btn
          v-else-if="isPreorder"
          pre-order-btn
          :size="(productPage || isModal) ? 'medium' : 'small'"
          :title-analytics="titleAnalytics"
          :product-id="productId"
          :code="code"
          :price="price"
          :productPage="productPage"
          :class="{ 'price-with-btn__btn-buy': inStock }"
        ></buy-btn>
        <wait-list-btn
          v-else
          :in-wait-list-status="isInWaitList"
          :product-id="productId"
          :productPage="productPage"
        ></wait-list-btn>
        <buy-btn
          v-if="productPage && inStock && !isManager"
          type="invert"
          size="medium"
          :title-analytics="titleAnalytics"
          :product-id="productId"
          :code="code"
          :price="price"
          one-click-btn
          class="price-with-btn__one-click-btn"
          :productPage="productPage"
        ></buy-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import BuyBtn from '@/components/cart/BuyBtn'
import WaitListBtn from '@/components/product/product-page/WaitListBtn'
import ProductPrice from '@/components/product/ProductPrice'

export default {
  name: 'PriceWithButton',
  components: {
    BuyBtn,
    WaitListBtn,
    ProductPrice
  },
  computed: {
    ...mapState({
      inStock: state => state.productInfo.productInfo.inStock,
      isPreorder: state => state.productInfo.productInfo.isPreorder,
      isNovelty: state => state.productInfo.productInfo.isNovelty,
      isInWaitList: state => state.productInfo.productInfo.isInWaitList,
      inWishListStatus: state => state.productInfo.productInfo.inWishListStatus,
      price: state => state.productInfo.productInfo.price,
      oldPrice: state => state.productInfo.productInfo.oldPrice,
      code: state => state.productInfo.productInfo.code,
      productId: state => state.productInfo.productInfo.productId,
      titleAnalytics: state => state.productInfo.productInfo.titleAnalytics,
      userStore: state => state.geoLocation.userStore,
      storesData: state => state.productInfo.productInfo.storesData,
      maxAvailableQuantity: state => state.productInfo.productInfo.maxAvailableQuantity
    }),
    availableInStore () {
      return !this.maxAvailableQuantity && this.storesData.find(el => +el.quantity > 0)
    },
    availableStoreId () {
      if (this.userStore && this.userStore.id) {
        const store = this.storesData.find(el => +el.id === +this.userStore.id)
        return store ? +store.id : null
      }
      return null
    },
    ...mapGetters(['isManager'])
  },
  props: {
    isModal: {
      type: Boolean,
      default: false
    },
    productTabs: {
      type: Boolean,
      default: false
    },
    productPage: {
      type: Boolean,
      default: false
    },
    withScrollingCard: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="sass">

.price-with-btn
  position: relative

.is-product-page
  width: 100%

  .price-with-btn__wrap
    display: flex
    flex-direction: column

    +mmin($large--mid)
      align-items: center
      flex-direction: row

  .price-with-btn__btn-wrap
    display: flex
    flex-direction: row
    width: 100%

    +mmin($large--mid)
      width: auto

      &:not(:first-child)
        margin-left: -146px

    div
      width: 100%

      +mmin($large--mid)
        width: auto

  .price-with-btn__price
    width: 100%
    margin-bottom: 20px
    flex-shrink: 0

    +mmin($large--mid)
      width: 48%
      margin-bottom: 0

  .price-with-btn__btn-buy
    margin-right: 10px
    width: 50%

    +mmin($tablet)
      margin-right: 15px

    +mmin($large--mid)
      margin-right: 0
      width: auto

  .price-with-btn__one-click-btn
    margin-left: 10px
    width: 50%

    +mmin($tablet)
      margin-left: 15px

    +mmin($large--mid)
      margin-left: 30px
      width: auto

.is-modal,
.is-product-tabs
  position: fixed
  bottom: 63px
  background-color: $white-text-color
  z-index: 4
  width: 100%
  box-shadow: 0px -5px 10px rgba(0, 0, 0, 0.07)
  border-radius: 13px 13px 0 0

  +mmin($tablet--hor)
    position: absolute
    bottom: auto
    right: 0
    top: 50%
    transform: translateY(-50%)
    z-index: 1
    width: max-content
    box-shadow: none

  .price-with-btn__wrap
    display: flex
    flex-flow: row nowrap
    justify-content: space-between
    align-items: center
    width: 100%
    max-width: 425px
    margin: 0 auto
    padding: 5px 15px

    +mmin($tablet--hor)
      padding: 0 15px

  .price-with-btn__price

    +mmin($tablet)
      margin-right: 40px

.is-modal
  +mmin($tablet)
    position: relative
    transform: none
    bottom: auto
    left: auto
    right: auto
    top: auto
    box-shadow: none
    width: max-content
  .price-with-btn__wrap
    max-width: none
    padding: 0 40px 10px 0
  .price-with-btn__price
    flex-direction: row-reverse
    ::v-deep
      .product-price__old
        margin-right: 20px

.is-with-scrolling-card
  left: 0
</style>
